import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { SearchRouteService } from './../../../Services/searchroute.service';
import { MainService } from 'src/app/Services/service.service';

@Component({
  selector: 'app-seo-texts',
  templateUrl: './seo-texts.component.html',
  styleUrls: ['./seo-texts.component.scss']
})
export class SeoTextsComponent implements OnInit {

  public currentItem: string;


  currentUrl: string = "";
  curentCategoryId: number = 0;
  casualDating: boolean = false;
  currentCityId: number = 0;

  constructor(private route: Router, public service: MainService, private searchRouteService: SearchRouteService) {    
    this.route.events.subscribe(event => {            
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;        
        this.mapRouting(this.getSEOView(this.currentUrl, this.curentCategoryId, this.currentCityId, this.casualDating));
      }
    });

    this.service.advService.resultListUpdate.subscribe(r => {
      this.curentCategoryId = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId;
      this.casualDating = this.service.advService.searchDataStandard.currentSearchRule.casualDating;
      this.currentCityId = this.service.advService.searchDataStandard.currentSearchRule.subRegionId;      
      this.mapRouting(this.getSEOView(this.currentUrl, this.curentCategoryId, this.currentCityId, this.casualDating));
    });

  }

  ngOnInit() {

  }

  isMappingValueByCity(cityId: number, casualDating: boolean): boolean {
    return this.getMappingValueByCity(cityId, casualDating) > 0;
  }

  getMappingValueByCity(cityId: number, casualDating: boolean): number {
    switch (cityId) {
      case 267: return 28;
      case 9806: return 29;
      case 16790: return 30;
      case 16794: return 31;
      case 16207: return 32;
      case 3881: return 33;
      case 23072: return 34;
      case 1611: return 35;
      case 16799: return 36;
      case 13957: return 37;
      case 5871: return 38;
      case 18304: return 39;
    }

    return 0;
  }

  getMappingValueByCategory(categoryId: number, casualDating: boolean): number {
    if (casualDating) {
      switch (categoryId) {
        case 5: return 2;
        case 1: return 8;
        case 2: return 10;
        case 9: return 4;
        case 6: return 12;
        case 10: return 13;
        case 3: return 14;
        case 7: return 17;
        case 11: return 19;
        case 4: return 20;
        case 8: return 22;
        case 12: return 23;
        case 17: return 26;
        case 16: return 41;
        case 15: return 43;
        case 14: return 45;
        case 13: return 47;
      }
      return 0;
    } else {
      switch (categoryId) {
        case 5: return 7;
        case 1: return 9;
        case 2: return 11;
        case 6: return 6;
        case 9: return 5;
        case 10: return 3;
        case 3: return 15;
        case 7: return 16;
        case 11: return 18;
        case 4: return 21;
        case 12: return 24;
        case 8: return 25;
        case 17: return 27;
        case 16: return 40;
        case 15: return 42;
        case 14: return 44;
        case 13: return 46;
      }
      return 0;
    }
  }

  getSEOView(curentUrl: string, currentCategoryId: number, cityId: number, isCasualDating: boolean) {
    if (this.currentUrl == "/") {
      return 1;
    }

    if (curentUrl == "/search-results") {
      if (this.isMappingValueByCity(cityId, isCasualDating)) {
        return this.getMappingValueByCity(cityId, isCasualDating);
      } else {
        return this.getMappingValueByCategory(currentCategoryId, isCasualDating);
      }
      
    } else {
      let keys = Object.keys(this.searchRouteService.categories);
      for (var i = 0; i < keys.length; i++) {
        if (this.currentUrl == `/long-term/${keys[i]}` || this.currentUrl == `/long-term/${keys[i]}/`) {
          return this.getMappingValueByCategory(this.searchRouteService.categories[keys[i]], false); 
        } else if (this.currentUrl == `/casual-dating/${keys[i]}` || this.currentUrl == `/casual-dating/${keys[i]}/`) {
          return this.getMappingValueByCategory(this.searchRouteService.categories[keys[i]], true);
        }
      }
    }

    return 0;
  }

  public mapRouting(id: number) {        
    switch (id) {

      case 1:
        this.currentItem = "home";
        return;
      case 2:
        this.currentItem = "Man-Seeking-Woman-Casual-Relationship";
        return;
      case 3:
        this.currentItem = "Couple Seeking Men for Long-Term Relationship";
        return;
      case 4:
        this.currentItem = "Couple Seeking Woman Casual Relationship";
        return;
      case 5:
        this.currentItem = "Couple Seeking Women for Long-Term Relationship";
        return;
      case 6:
        this.currentItem = "Man-Seeking-Man-Long-Term";
        return;
      case 7:
        this.currentItem = "Man-Seeking-Woman-Long-Term-Relationship";
        return;
      case 8:
        this.currentItem = "Woman-Seeking-Man-Casual Relationship";
        return;
      case 9:
        this.currentItem = "Woman-Seeking-Man-Long-Term";
        return;
      case 10:
        this.currentItem = "Woman-Seeking-Woman-Casual-Relationship";
        return;
      case 11:
        this.currentItem = "Woman-Seeking-Woman-Long-Term-Relationship";
        return;
      case 12:
        this.currentItem = "Man Seeking Man for Casual Relationship";
        return;
      case 13:
        this.currentItem = "Couple Seeking Men for Casual Relationship";
        return;
      case 14:
        this.currentItem = "Woman Seeking Couple for Casual Relationship";
        return;
      case 15:
        this.currentItem = "Woman Seeking Couple for Long-Term Relationship";
        return;
      case 16:
        this.currentItem = "Man Seeking Couple for Long-Term Relationship";
        return;
      case 17:
        this.currentItem = "Man Seeking Couple for Casual Relationship";
        return;
      case 18:
        this.currentItem = "Couple Seeking Couple for Long-Term";
        return;
      case 19:
        this.currentItem = "Couple Seeking Couple for Casual Relationship";
        return;
      case 20:
        this.currentItem = "Women Seeking Transgender for Casual Relationship";
        return;
      case 21:
        this.currentItem = "Women Seeking Transgender for Real and Ardent Long-Term Relationship";
        return;
      case 22:
        this.currentItem = "Men Seeking Transgenders for Casual Relationship";
        return;
      case 23:
        this.currentItem = "Couple Seeking Transgender for Casual Sex Relationship";
        return;
      case 24:
        this.currentItem = "Couple Seeking Transgender for Long-Term Relationship";
        return;
      case 25:
        this.currentItem = "Men Seeking Transgenders for Committed Long-Term Relationship";
        return;
      case 26:
        this.currentItem = "Missed Connections with Sexy Hotty";
        return;
      case 27:
        this.currentItem = "Missed Connection LongTerm";
        return;
      case 28:
        this.currentItem = "Birmingham, Alabama with Ease!";
        return;
      case 29:
        this.currentItem = "Find Dates in Baltimore";
        return;
      case 30:
        this.currentItem = "Your Perfect Wingman in Bronx";
        return;
      case 31:
        this.currentItem = "Experience Modern Dating Ease in Brooklyn, New York with Wickedlist!";
        return;
      case 32:
        this.currentItem = "Wickedlist – Your Guide to Love & Casual Flings in Albuquerque, New Mexico!";
        return;
      case 33:
        this.currentItem = "Dates, Hookups & Everything In-Between in Atlanta, Georgia – Wickedlist!";
        return;
      case 34:
        this.currentItem = "Wickedlist – Finding Love & Getting Laid in Austin, Texas Made Easy!";
        return;
      case 35:
        this.currentItem = "Date & Hookup with Ease in Bakersfield, California – Wickedlist!";
        return;
      case 36:
        this.currentItem = "Find Your Ideal Partner in Buffalo, New York with Wickedlist";
        return;
      case 37:
        this.currentItem = "Wickedlist – Ultimate Date-Finder in Charlotte, North Carolina";
        return;
      case 38:
        this.currentItem = "Change Your Dating Fortunes in Chicago, Illinois Today with Wickedlist!"
        return;
      case 39:
        this.currentItem = "Cincinnati, Ohio – Discover Modern Dating Convenience with Wickedlist!"
        return;
      case 40:
        this.currentItem = "Transgender Seeking Transgender for Long-Term Relationship Magic";
        return;
      case 41:
        this.currentItem = "Transgender Seeking a Transgender for Casual Sex Relationship";
        return;
      case 42:
        this.currentItem = "Transgender Seeking Couple for Long-Term Relationship and Mutual Pleasure";
        return;
      case 43:
        this.currentItem = "Transgender Seeking Couple for Casual Relationship and Hot Threesome Fun";
        return;
      case 44:
        this.currentItem = "Transgender Seeking Man for Long-Term Relationship and Reliable Bond";
        return;
      case 45:
        this.currentItem = "Transgender Seeking Man for Casual Sex Relationship and Kinky Fun";
        return;
      case 46:
        this.currentItem = "Transgender Seeking Women for Long-Term Relationship and Committed Bliss";
        return;
      case 47:
        this.currentItem = "Transgender Seeking Women for Casual Relationship and Sexperiments";
        return;
    }
    this.currentItem = null;
  }


}
